'use strict';

// The work details that decide which documents complete a candidate's Integrity Check. The server
// judges completion from them and every screen that names the candidate's type or EAD category
// reads them here, so both always read the same values.
//
// The type is kept in the work details, and on older profiles only in the onboarding answers;
// the EAD category is kept only in the onboarding answers.
//
// Written as plain CommonJS with no imports so the API server, which runs its files under plain
// node, can require this same file the browser bundle imports.

const valueOf = value => (value === undefined ? null : value);

/**
 * @param {Object} publicData - a profile's (or a profile listing's) public data
 * @returns {{ workAuthType: *, eadCategory: *, countryOfCitizenship: *, eligibleForRolesInUs: * }}
 *   each null when the profile does not hold it
 */
function workProfileOfPublicData(publicData) {
  const data = publicData || {};
  const details = data.identityAndWorkAuthorizationDetails || {};
  const onBoardingInfo = data.onBoardingInfo || {};

  return {
    workAuthType: valueOf(details.workAuthType || onBoardingInfo.workAuthType),
    eadCategory: valueOf(onBoardingInfo.eadCategory),
    countryOfCitizenship: valueOf(details.countryOfCitizenship),
    eligibleForRolesInUs: valueOf(details.eligibleForRolesInUs),
  };
}

/**
 * The server reads these from the user record it fetched itself - never from a request body or
 * the candidate's listing, either of which the candidate could write anything into.
 *
 * @param {Object} user - a user record as the server read it
 * @returns {{ workAuthType: *, eadCategory: *, countryOfCitizenship: *, eligibleForRolesInUs: * }}
 */
function workProfileOf(user) {
  return workProfileOfPublicData(user?.attributes?.profile?.publicData);
}

module.exports = {
  workProfileOf,
  workProfileOfPublicData,
};
